import { useNavigate } from 'react-router-dom';

import './infoUser.css';


export const GestionarCuenta = () => {
  /* const dispatch = useDispatch(); */
  const navigate = useNavigate();

  const gestionarCuenta = () => {
    /* dispatch(iniCreateCompras()); */
    navigate(`/ajustes/cuenta`);
    console.log('Gestionar Cuenta')
  }


  return (
    <button className='btn p-btn-light-info-user m-3' onClick={gestionarCuenta} target="_blank">
      {/* <img  alt="Gestionar Cuenta" /> */} Gestionar tu cuenta
    </button>
  )
}
